import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  planzones: [],
};

function handleRequest(state: State) {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(
  state: State,
  planzones: Boundaries["retrievePlanzones"]["success"],
) {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
    planzones,
  };
}

function handleFailure(state: State) {
  return {
    ...state,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = createStateReducer(initialState, {
  [events.retrievePlanzonesRequested]: handleRequest,
  [events.retrievePlanzonesSucceeded]: handleSuccess,
  [events.retrievePlanzonesFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
